import { Landmark, ShieldCheck, BarChart3, Leaf } from "lucide-react";

export const iconMap = {
  Landmark,
  ShieldCheck,
  BarChart3,
  Leaf,
};

export const getIcon = (name) => iconMap[name] || Landmark;
